import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=6f1ba026&"
import script from "./ForgotPass.vue?vue&type=script&lang=ts&"
export * from "./ForgotPass.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports